import type { AssetTypeTemplatePageHeaderProps } from "./asset-type-template-page-header.type";

import BaseHeader from "@/components/Header/BaseHeader";
import { AssetTypeTemplateHeaderButtons } from "@/modules/asset-type-template/asset-type-template-header-buttons";

export const AssetTypeTemplatePageHeader = ({
  template,
  loading,
}: AssetTypeTemplatePageHeaderProps) => {
  return (
    <BaseHeader
      title={template?.name}
      loading={loading}
      extra={
        <AssetTypeTemplateHeaderButtons
          key="HeaderButtons"
          template={template}
        />
      }
    />
  );
};
